import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Exam } from 'models/ExamModel';
import { create } from 'domain';


const ExamList: React.FC = () => {
  const width = { client: 20, type: 15, comment: 16, doctor: 15, date:12, createdby: 14 };
  const [formId, formName] = [Code.Form.Id.EXAM, Code.Form.Name.EXAM];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, iframeRef2, filterRef, contextMenuRef  } = useListContext();
  const [examData, setExamData] = useState<Exam[]>([]); 
  const [selectedExam, setselectedExam] = useState<Exam | null>(null);
  const triggers = [pno, pageRows, search, activeId];
  const Privilege = Hooks.Privilege.List(formId);
  const locationId = Utility.Storage.LocationId();

  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Exam.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Exam.Id, 
        Name.Client.Id, 
        Name.Client.FullName, 
        Name.ExamType.Name,
        Name.Exam.Comment,
        Name.Doctor.FullName, 
        Name.Exam.Date,
        Name.Exam.Data2,
        Name.Exam.Data3,
        Name.User.FullName
      ]),
      location_id: locationId,
    });
     
    await API.Data.List<Exam>(url, setExamData, setError, setLoading); 
  }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName, "data", "1")} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.State} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, examData, setSelectAllChecked,formName)} extra={4} />
              <Control.Grid.Items values={[
                [Title.ClientName, width.client],
                [Title.Type, width.type], 
                [Title.Doctor, width.doctor], 
                [Title.Comment, width.comment], 
                [Title.Date, width.date], 
                [Title.CreatedBy, width.createdby], 
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(examData) && (
              <Control.Grid.Row>
                {examData.map((examData) => { const path = Utility.Join.Edit(Privilege, formName, examData.exam_key); return (
                <Control.Grid.Data<Exam> key={examData.exam_id} itemKey={examData.exam_key} data={examData} setMenuPosition={setMenuPosition} setSelectedData={setselectedExam} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={examData.exam_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Print path={`${Utility.Join.Print(Privilege, formName, examData.exam_key)}?data=1`} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Double path={`${path}?data=1`} path2={`compare/${examData.exam_key}?data=1`} iframeRef={iframeRef} iframeRef2={iframeRef2} Privilege={Privilege} title='Open first exam' />
                  <Control.Grid.Double path={`${path}?data=2`} path2={`compare/${examData.exam_key}?data=2`} iframeRef={iframeRef} iframeRef2={iframeRef2} Privilege={Privilege} title='Open second exam' icon={`num2 noicon${examData.exam_data2?.length}`} />
                  <Control.Grid.Double path={`${path}?data=3`} path2={`compare/${examData.exam_key}?data=3`} iframeRef={iframeRef} iframeRef2={iframeRef2} Privilege={Privilege} title='Open third exam' icon={`num3 noicon${examData.exam_data3?.length}`} />
                  <Control.Grid.Link path={Utility.Join.Edit(Privilege, Code.Form.Name.CLIENT, examData.client_id)} value={Utility.Get.FullName(examData,Code.Form.Name.CLIENT)} width={width.client} iframeRef={iframeRef} title={Code.Form.Name.CLIENT} />
                  <Control.Grid.Items values={[
                    [examData.examtype_name, width.type], 
                    [Utility.Get.FullName(examData,Code.Form.Name.DOCTOR), width.doctor],
                    [examData.exam_comment, width.comment],
                    [Utility.Format.DateOnly(examData.exam_date), width.date],
                    [Utility.Get.FullName(examData,Code.Form.Name.USER), width.createdby],
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={examData.exam_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={examData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName,selectedExam?.exam_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedExam?.exam_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Control.FormPopup2 iframeRef={iframeRef2} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default ExamList;